"use client";
import React, { useEffect, useRef, useState } from "react";
import RetirementStepsTitle from "./RetirementStepsTitle";
import RetirementDurationWheel from "./RetirementDurationWheel";
import {
  DEFAULT_RETIREMENT_DURATION,
  MAX_RETIREMENT_DURATION,
  MIN_RETIREMENT_DURATION,
} from "@/utils/financialPageFunctions";

export default function PostRetirementDurationScreen({
  stepTitle,
  retirementDuration,
  onRetirementDurationAction,
  validateTrigger,
}: {
  stepTitle?: string;
  retirementDuration: number;
  onRetirementDurationAction: (v: number) => void;
  validateTrigger?: number;
}) {
  const [error, setError] = useState("");

  const validate = (years: number) => {
    if (isNaN(years) || years < MIN_RETIREMENT_DURATION || years > MAX_RETIREMENT_DURATION) {
      setError(`Retirement duration must be between ${MIN_RETIREMENT_DURATION} and ${MAX_RETIREMENT_DURATION} years.`);
      return false;
    }
    setError("");
    return true;
  };

  const prevTrigger = useRef(0);
  const durationRef = useRef(retirementDuration);
  durationRef.current = retirementDuration;

  useEffect(() => {
    if (!validateTrigger || validateTrigger === prevTrigger.current) return;
    prevTrigger.current = validateTrigger;
    validate(durationRef.current);
  }, [validateTrigger]);

  const recommendedFloor = Math.max(retirementDuration, DEFAULT_RETIREMENT_DURATION);

  return (
    <div className="flex flex-col h-full">
      <RetirementStepsTitle stepTitle={stepTitle || "Select Your Retirement Duration"} />

      <RetirementDurationWheel
        value={retirementDuration}
        min={MIN_RETIREMENT_DURATION}
        max={MAX_RETIREMENT_DURATION}
        onChangeAction={(years) => {
          setError("");
          onRetirementDurationAction(years);
        }}
      />

      {error && <p className="mt-2 text-xs text-red-500 text-center">{error}</p>}

      <div className="mt-auto mx-auto w-fit border border-[#C6D3EA] rounded-full px-3 py-2.5 sm:px-7 sm:py-3.5 text-sm sm:text-base font-medium text-[#003D6C96] text-center">
        Your Retirement will last till <span className="font-bold text-black">{recommendedFloor} Years</span>
      </div>
    </div>
  );
}
